import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './../components/authProvider';


const _NAVIGATION = [
    { title: "Overview", url: "/app/overview", icon: "fa-solid fa-house", },
    { title: "Your Profile", url: "/app/profile", icon: "fa-solid fa-user", },
    { title: "Members", url: "/app/members", icon: "fa-solid fa-users", },
    { isBreaker: true },
    { title: "Domains", url: "/app/domains", icon: "fa-solid fa-globe", },
    { title: "Email Rules", url: "/app/rules", icon: "fa-solid fa-sliders", },
    { title: "Email Delivery", url: "/app/deliveries", icon: "fa-solid fa-paper-plane", },
    { isBreaker: true },
    { title: "History", url: "/app/history", icon: "fa-solid fa-envelope-open-text", },
    { title: "Billing", url: "/app/billing", icon: "fa-solid fa-receipt", },
    { isBreaker: true },
    { title: "Microsoft Exchange", url: "/app/exchange", icon: "fa-brands fa-microsoft", },
    { title: "Monitoring", url: "/app/monitoring", icon: "fa-solid fa-server", },
    { forAdmin: true, isBreaker: true },
    { forAdmin: true, title: "Tools", url: "/app/admin/tools", icon: "fa-solid fa-bell", }
];


const AppLayout = ({ children }) => {
    const { authUser } = useAuth();
    const currentLocation = useLocation();
    const isMobile = window.innerWidth < 768;

    return <main className="d-flex  overflow-auto bg-light" style={{ minHeight: 'calc(100vh - 385px)' }}>
        <aside className="p-3 mb-5" style={{ minWidth: isMobile ? '160px' : '250px', width: isMobile ? '160px' : '250px' }}>
            <ul className={"nav flex-column " + (isMobile ? "fs-7" : "fs-6")}>
                {_NAVIGATION.map((navItem, navItemIndex) => {
                    const isActive = (navItem.url === currentLocation.pathname);
                    if (navItem?.forAdmin !== true || authUser?.isSuperAdmin === true) {
                        return <li className="nav-item" key={navItemIndex}>
                            {navItem?.isBreaker === true
                                ? <hr className="my-2" />
                                : <Link
                                    to={navItem.url}
                                    className={"nav-link text-dark border-0 rounded-2" + (isActive ? " active" : "")}
                                    style={{
                                        textDecoration: 'none',
                                        backgroundColor: isActive ? '#f8e9a1' : 'transparent'
                                    }}
                                >
                                    <span className="me-2">
                                        <i className={navItem.icon} />
                                    </span>
                                    {navItem.title}</Link>

                            }
                        </li>
                    }
                })}
            </ul>
        </aside>
        <section className="flex-grow-1 flex-column h-100 pt-3 ps-2 pe-5 mb-5">
            <div className="bg-white w-100 border border-1 border-sm rounded-3 shadow-sm p-0 m-0">
                <div className="d-flex flex-column h-100">
                    {children}
                </div>
            </div>
        </section>
    </main>
};

export default AppLayout;